export default __webpack_public_path__ + "static/media/bmw-340.0dd9ad60.png";